import React, { Component } from 'react';
import PhotoCardsSwiper from "../components/PhotoCardsSwiper";
import { Link } from "react-router-dom";

const cardImages = [
  "images/Blog/cardsalarv1.jpg",
  "images/Blog/cardsalarv2.jpg",
  "images/Blog/cardsalarv3.jpg",
  "images/Blog/cardsalarv4.jpg"
];


class NuevaSalaRV extends Component {
  componentDidMount() {
  if (window.startx) {
    window.startx();
  }
}
  render() {
    return (
      <div id="main" className="wrapper style1">
        <div className="container">
          <header className="major">
            <h2> Nueva Sala de Realidad Virtual: <br/>
            Una experiencia inmersiva para todas las edades</h2>
          </header>
          <div className="containerimagenblog">
            <img className="imagenBlog" src="images/Blog/salarvportada.jpg" alt="Sala de Realidad Virtual" />
          </div>
          <div className="containerblog">
            <div className="align justify">
              <p>
                La nueva Sala de Realidad Virtual llega para abrir la puerta a un mundo donde la 
                tecnología, la imaginación y la diversión se combinan en una experiencia única. 
                Esta sala ofrece atracciones innovadoras que permiten vivir aventuras increíbles 
                a través de simuladores y entornos de realidad virtual y aumentada. 
                Cada módulo ha sido pensado para estimular los sentidos, la coordinación y la emoción, brindando 
                experiencias seguras, dinámicas y llenas de adrenalina. 
                Las y los visitantes pueden disfrutar de los siguientes módulos interactivos:
              </p>

              <ul> 
                <li> 
                  <strong> <span role="img" aria-label="bandera a cuadros">🏁</span> AR Racing </strong><br /> 
                  Un emocionante simulador de carreras con realidad aumentada, donde podrás conducir carritos 
                  reales dentro de un circuito desafiante. La tecnología AR transforma el recorrido en una experiencia 
                  envolvente, combinando el mundo físico con elementos digitales que ponen a prueba reflejos y 
                  habilidades de conducción. 
                </li> 
                <li> 
                  <strong> <span role="img" aria-label="camión futurista">🚙</span> Cybertruck VR </strong><br /> 
                  Súbete a una experiencia futurista y vive la sensación de manejar un vehículo de alto impacto en 
                  escenarios virtuales sorprendentes, llenos de retos y emoción. 
                </li> 
                <li>
                  <strong> <span role="img" aria-label="huevo">🥚</span> Huevo VR </strong><br /> 
                  Un módulo envolvente que transporta a los participantes a una aventura fuera de lo común, ideal 
                  para quienes buscan una experiencia inmersiva y diferente dentro del mundo virtual. 
                </li> 
                <li>
                  <strong> <span role="img" aria-label="motocicleta">🏍️</span> Hyper Moto VR </strong><br /> 
                  Velocidad y adrenalina se combinan en este simulador que permite vivir la experiencia de conducir una 
                  motocicleta en pistas virtuales llenas de acción y desafíos. 
                </li> 
                <li> 
                  <strong> <span role="img" aria-label="resbaladilla">🛝</span> VR Slide </strong><br /> 
                  Una atracción que mezcla movimiento físico con realidad virtual, creando la sensación de deslizarse por
                   escenarios increíbles que sorprenden en cada recorrido. 
                </li> 
              </ul>

              <p>
              La Sala de Realidad Virtual representa un nuevo espacio donde la tecnología se convierte en una herramienta para el 
              entretenimiento, la exploración y la innovación. Es una invitación a descubrir cómo la realidad virtual y aumentada 
              pueden transformar la forma en que jugamos, aprendemos y nos divertimos. Te invitamos a vivir esta experiencia y a ser 
              parte de una nueva era de atracciones que combinan creatividad, emoción y tecnología en un solo lugar.
              </p>
            </div>
           {/* GALERÍA REUTILIZABLE */}
            <div className="container">

              <h3 className='section-title'>Momentos Destacados</h3>
              <PhotoCardsSwiper images={cardImages} />
            </div>
            <div>
              <div className="containerjuego">
                <Link className="button" to="/blog">
                Ver Blog
              </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NuevaSalaRV;